export default __webpack_public_path__ + "static/media/tete10.d83a238b.png";